import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col md:flex-row" }
const _hoisted_2 = { class: "hidden md:block bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_3 = { class: "flex justify-end mt-7" }
const _hoisted_4 = { class: "bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_5 = { class: "grid gap-4" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex justify-end mt-7" }
const _hoisted_8 = { class: "flex justify-end items-center md:flex-grow" }
const _hoisted_9 = {
  class: "md:hidden",
  style: {"height":"calc(100vh - 177px)"}
}
const _hoisted_10 = { class: "custom-title flex flex-col" }
const _hoisted_11 = { class: "ml-auto" }
const _hoisted_12 = { class: "flex items-center space-x-1" }
const _hoisted_13 = { class: "text-white" }
const _hoisted_14 = { style: {"overflow-y":"auto","height":"calc(100vh - 227px)"} }
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = { class: "text-5xl" }
const _hoisted_17 = { class: "flex flex-col justify-between" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "flex flex-col justify-between" }
const _hoisted_21 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_22 = { class: "text-sm text-gray-500" }
const _hoisted_23 = { class: "hidden md:block w-full" }
const _hoisted_24 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_25 = { class: "flex w-full justify-end mt-4" }
const _hoisted_26 = { class: "hidden md:block mr-3" }
const _hoisted_27 = { class: "md:hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrganizationSelect = _resolveComponent("OrganizationSelect")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DepartmentSelect = _resolveComponent("DepartmentSelect")!
  const _component_CategorySelect = _resolveComponent("CategorySelect")!
  const _component_AutoCompleteInput = _resolveComponent("AutoCompleteInput")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_mian = _resolveComponent("el-mian")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, { style: {"height":"calc(100vh - 52px)"} }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, {
        style: {"height":"auto"},
        class: "bg-gray-200 p-3 md:p-5"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_form, {
                model: _ctx.searchForm,
                "label-width": "auto",
                "label-position": "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["grid gap-4", [
                                _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'md:grid-cols-6' : (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead ? 'md:grid-cols-5' : 'md:grid-cols-4'),
                            ]])
                  }, [
                    _withDirectives(_createVNode(_component_el_form_item, {
                      class: "no-margin",
                      label: "組織"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_OrganizationSelect, {
                          modelValue: _ctx.searchForm.organization_id,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                          "is-search": true,
                          placeholder: "組織を選択"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
                    ]),
                    _withDirectives(_createVNode(_component_el_form_item, {
                      class: "no-margin",
                      label: "部門"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DepartmentSelect, {
                          "organization-id": _ctx.searchForm.organization_id,
                          "is-search": true,
                          modelValue: _ctx.searchForm.department_id,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.department_id) = $event)),
                          placeholder: "部門を選択",
                          onOrganizationIdChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchForm.organization_id = $event))
                        }, null, 8, ["organization-id", "modelValue"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead)]
                    ]),
                    _createVNode(_component_el_form_item, {
                      class: "no-margin",
                      label: "カテゴリ"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CategorySelect, {
                          "organization-id": _ctx.searchForm.organization_id,
                          "is-search": true,
                          modelValue: _ctx.searchForm.category_id,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchForm.category_id) = $event)),
                          placeholder: "カテゴリを選択"
                        }, null, 8, ["organization-id", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      class: "no-margin",
                      label: "アイテム名"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AutoCompleteInput, {
                          modelValue: _ctx.searchForm.material_name,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchForm.material_name) = $event)),
                          placeholder: "アイテム名を入力",
                          "storage-key": "material-name-history",
                          "max-history-items": 15,
                          ref: "materialNameInput"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      class: "no-margin",
                      label: "アラート"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.searchForm.time_filter,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchForm.time_filter) = $event)),
                          placeholder: "アラートを選択",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "すべて",
                              value: "すべて"
                            }),
                            _createVNode(_component_el_option, {
                              label: "1日前",
                              value: "1日前"
                            }),
                            _createVNode(_component_el_option, {
                              label: "3日前",
                              value: "3日前"
                            }),
                            _createVNode(_component_el_option, {
                              label: "7日前",
                              value: "7日前"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_button, {
                        class: "hidden md:block w-24",
                        type: "info",
                        onClick: _ctx.handleSearchButton
                      }, {
                        default: _withCtx(() => _cache[28] || (_cache[28] = [
                          _createTextVNode("検索")
                        ])),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _createVNode(_component_el_drawer, {
              class: "md:hidden bg-gray-200",
              modelValue: _ctx.drawer,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.drawer) = $event)),
              title: "検索",
              direction: "ttb",
              "with-header": false,
              size: "auto"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_form, {
                    model: _ctx.searchForm,
                    "label-width": "auto",
                    "label-position": "top"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _withDirectives(_createVNode(_component_el_form_item, {
                          class: "no-margin",
                          label: "組織"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_OrganizationSelect, {
                              modelValue: _ctx.searchForm.organization_id,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                              "is-search": true,
                              placeholder: "組織を選択"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
                        ]),
                        _withDirectives(_createVNode(_component_el_form_item, {
                          class: "no-margin",
                          label: "部門"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DepartmentSelect, {
                              "organization-id": _ctx.searchForm.organization_id,
                              "is-search": true,
                              modelValue: _ctx.searchForm.department_id,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchForm.department_id) = $event)),
                              placeholder: "部門を選択",
                              onOrganizationIdChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.searchForm.organization_id = $event))
                            }, null, 8, ["organization-id", "modelValue"])
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead)]
                        ]),
                        _createVNode(_component_el_form_item, {
                          class: "no-margin",
                          label: "カテゴリ"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CategorySelect, {
                              "organization-id": _ctx.searchForm.organization_id,
                              "is-search": true,
                              modelValue: _ctx.searchForm.category_id,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchForm.category_id) = $event)),
                              placeholder: "カテゴリを選択"
                            }, null, 8, ["organization-id", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          class: "no-margin",
                          label: "アラート"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.searchForm.time_filter,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchForm.time_filter) = $event)),
                              placeholder: "アラートを選択",
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "すべて",
                                  value: "すべて"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "1日前",
                                  value: "1日前"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "3日前",
                                  value: "3日前"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "7日前",
                                  value: "7日前"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_el_form_item, {
                            class: "no-margin flex-grow",
                            label: "アイテム名"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_AutoCompleteInput, {
                                modelValue: _ctx.searchForm.material_name,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchForm.material_name) = $event)),
                                placeholder: "アイテム名を入力",
                                "storage-key": "material-name-history",
                                "max-history-items": 15,
                                ref: "materialNameInput"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_el_button, {
                              class: "md:hidden ml-3",
                              type: "info",
                              onClick: _ctx.handleSearchButton,
                              circle: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                                    _createElementVNode("span", { class: "material-symbols-outlined" }, "manage_search", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["model"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_button, {
                class: "custom-icon-btn md:hidden",
                type: "info",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.drawer = true)),
                circle: ""
              }, {
                default: _withCtx(() => _cache[30] || (_cache[30] = [
                  _createElementVNode("span", { class: "material-symbols-outlined" }, " manage_search ", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_el_button, {
                class: "custom-icon-btn",
                type: "info",
                onClick: _ctx.handleExportButton,
                circle: ""
              }, {
                default: _withCtx(() => _cache[31] || (_cache[31] = [
                  _createElementVNode("span", { class: "material-symbols-outlined" }, " download_2 ", -1)
                ])),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_mian, { style: {"padding-bottom":"20px"} }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[37] || (_cache[37] = _createElementVNode("span", null, "定数管理（過不足　品名　在庫数　定数）", -1)),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[36] || (_cache[36] = _createElementVNode("span", { class: "text-white" }, "ソート:", -1)),
                  _createVNode(_component_el_button, {
                    size: "small",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleSort('material_name'))),
                    class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'material_name' ? 'active' : ''])
                  }, {
                    default: _withCtx(() => _cache[32] || (_cache[32] = [
                      _createTextVNode(" アイテム名 ")
                    ])),
                    _: 1
                  }, 8, ["class"]),
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        size: "small",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleSort('organization_name'))),
                        class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'organization_name' ? 'active' : ''])
                      }, {
                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                          _createTextVNode(" 組織 ")
                        ])),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        size: "small",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleSort('department_name'))),
                        class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'department_name' ? 'active' : ''])
                      }, {
                        default: _withCtx(() => _cache[34] || (_cache[34] = [
                          _createTextVNode(" 部門 ")
                        ])),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    size: "small",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleSort('difference'))),
                    class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'difference' ? 'active' : ''])
                  }, {
                    default: _withCtx(() => _cache[35] || (_cache[35] = [
                      _createTextVNode(" 過不足 ")
                    ])),
                    _: 1
                  }, 8, ["class"]),
                  _createElementVNode("span", _hoisted_13, "アイテム数: " + _toDisplayString(_ctx.mTotalRecords), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mTableData, (item) => {
                return (_openBlock(), _createBlock(_component_el_card, {
                  key: item.id,
                  style: {"border":"1px solid #d1d5db","border-radius":"0px"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_el_checkbox, {
                        class: "absolute top-[-6px] right-1",
                        "model-value": _ctx.selectedItems.some(t => t.inventory_id === item.inventory_id),
                        size: "large",
                        onChange: ($event: any) => (_ctx.handleCheckboxChange(item))
                      }, null, 8, ["model-value", "onChange"]),
                      _createVNode(_component_el_row, {
                        align: "middle",
                        class: "relative z-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, {
                            span: 8,
                            align: "middle"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_16, _toDisplayString(item.quantity - item.constantQuantity), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, {
                            span: 15,
                            class: "ml-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_17, [
                                (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(item.organization_name), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(item.department_name), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", null, _toDisplayString(item.material_name), 1),
                                (item.category_name)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(item.category_name), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode(_component_el_row, { align: "middle" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, " 在庫数：" + _toDisplayString(item.quantity), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, " 定数：" + _toDisplayString(item.constantQuantity), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              (item.last_export_date)
                                ? (_openBlock(), _createBlock(_component_el_row, {
                                    key: 0,
                                    align: "middle"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_col, { span: 24 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_22, " 最終出力日時：" + _toDisplayString(_ctx.moment(item.last_export_date).format('YYYY-MM-DD HH:mm')), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_23, [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _ctx.mTableData,
              height: "calc(100vh - 260px)"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  width: "55",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_checkbox, {
                      "model-value": _ctx.selectedItems.some(t => t.inventory_id === scope.row.inventory_id),
                      size: "large",
                      onChange: ($event: any) => (_ctx.handleCheckboxChange(scope.row))
                    }, null, 8, ["model-value", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "organization_name",
                  label: "組織",
                  width: "200"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "flex items-center cursor-pointer whitespace-nowrap",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleSort('organization_name')))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('organization_name')), 1),
                      _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'organization_name' }])
                          }, _toDisplayString(_ctx.getSortIcon('organization_name')), 3)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "department_name",
                  label: "部門",
                  width: "160"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "flex items-center cursor-pointer whitespace-nowrap",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleSort('department_name')))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('department_name')), 1),
                      _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'department_name' }])
                          }, _toDisplayString(_ctx.getSortIcon('department_name')), 3)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "category_name",
                  label: "カテゴリ",
                  width: "160"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "flex items-center cursor-pointer whitespace-nowrap",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleSort('category_name')))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('category_name')), 1),
                      _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'category_name' }])
                          }, _toDisplayString(_ctx.getSortIcon('category_name')), 3)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "material_name",
                  label: "アイテム名",
                  "min-width": "400"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "flex items-center cursor-pointer whitespace-nowrap",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleSort('material_name')))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('material_name')), 1),
                      _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'material_name' }])
                          }, _toDisplayString(_ctx.getSortIcon('material_name')), 3)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.material_name), 1),
                    _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
                    (scope.row.jancode)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, " （" + _toDisplayString(scope.row.jancode) + "） ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "quantity",
                  label: "在庫数",
                  width: "80",
                  "header-align": "center",
                  align: "right"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "flex items-center cursor-pointer whitespace-nowrap",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleSort('quantity')))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('quantity')), 1),
                      _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'quantity' }])
                          }, _toDisplayString(_ctx.getSortIcon('quantity')), 3)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "constantQuantity",
                  label: "定数",
                  width: "80",
                  "header-align": "center",
                  align: "right"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "flex items-center cursor-pointer whitespace-nowrap",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleSort('constantQuantity')))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('constantQuantity')), 1),
                      _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'constantQuantity' }])
                          }, _toDisplayString(_ctx.getSortIcon('constantQuantity')), 3)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "過不足",
                  width: "80",
                  "header-align": "center",
                  align: "right"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "flex items-center cursor-pointer whitespace-nowrap",
                      onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleSort('difference')))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('difference')), 1),
                      _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'difference' }])
                          }, _toDisplayString(_ctx.getSortIcon('difference')), 3)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.quantity - scope.row.constantQuantity), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "last_export_date",
                  label: "最終出力日時",
                  width: "160"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "flex items-center cursor-pointer whitespace-nowrap",
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.handleSort('last_export_date')))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('last_export_date')), 1),
                      _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'last_export_date' }])
                          }, _toDisplayString(_ctx.getSortIcon('last_export_date')), 3)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.last_export_date ? _ctx.moment(scope.row.last_export_date).format('YYYY-MM-DD HH:mm:ss') : '-'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_el_pagination, {
                "current-page": _ctx.mCurrentPage,
                "onUpdate:currentPage": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.mCurrentPage) = $event)),
                "page-size": _ctx.mPageSize,
                "onUpdate:pageSize": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.mPageSize) = $event)),
                "page-sizes": [10, 20, 50, 100],
                layout: "total, sizes, prev, pager, next, jumper",
                total: _ctx.mTotalRecords,
                onSizeChange: _ctx.handleSizeChange,
                onCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_el_pagination, {
                layout: "prev, pager, next",
                total: _ctx.mTotalRecords,
                onCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["total", "onCurrentChange"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}